import styled from '@emotion/styled'
import { Caption } from 'components/Typography'

export const SCapsule = styled.div`
  border: 1px solid #e5f2f8;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  padding: 16px;
`

export const SCapsuleHeading = styled(Caption)`
  color: var(--c-gray100);
  display: flex;
  align-items: center;
`
